import React from 'react';
import {Chip, Stack} from '@mui/material';

const STATUS_STYLES: Record<string, {label: string; color: string; bg: string; border?: string}> = {
  live: {label: 'Live', color: '#166534', bg: '#dcfce7'},
  upcoming: {label: 'Upcoming', color: '#1d4ed8', bg: '#dbeafe'},
  finished: {label: 'Finished', color: '#4b5563', bg: '#f3f4f6'}
};

const HIDDEN_STYLE = {label: 'Hidden', color: '#6b7280', bg: 'transparent', border: '1px solid #d1d5db'};

const StatusChip = ({style}: {style: {label: string; color: string; bg: string; border?: string}}) => (
  <Chip
    size="small"
    label={style.label}
    sx={{
      height: 24,
      fontWeight: 700,
      fontSize: 11,
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      color: style.color,
      backgroundColor: style.bg,
      border: style.border || 'none',
      '& .MuiChip-label': {px: 1}
    }}
  />
);

const EventStatusBadge = ({status, hidden}: {status?: string; hidden?: boolean}) => {
  const key = (status || '').toLowerCase();
  const style = STATUS_STYLES[key] || STATUS_STYLES.finished;

  return (
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" alignItems="center">
      <StatusChip style={style} />
      {hidden ? <StatusChip style={HIDDEN_STYLE} /> : null}
    </Stack>
  );
};

export default EventStatusBadge;
